// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__b+xoC","pageButton":"Pagination_pageButton__4dggS","active":"Pagination_active__BZM5d","arrow":"Pagination_arrow__U6rHp"};